import React from "react";

const VerificationDetail = ({ title, description }) => (
  <div className="m_10_bottom">
    <strong>{title}</strong>
    {description}
  </div>
);

export default VerificationDetail;
